import { render, staticRenderFns } from "./img-text-exchange-order.vue?vue&type=template&id=e1ece3ea&scoped=true&"
import script from "./img-text-exchange-order.vue?vue&type=script&lang=js&"
export * from "./img-text-exchange-order.vue?vue&type=script&lang=js&"
import style0 from "./img-text-exchange-order.vue?vue&type=style&index=0&id=e1ece3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ece3ea",
  null
  
)

export default component.exports